import { useState } from 'react';

const useDeleteConversation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDeleteConversation = async (conversationId) => {
    setIsLoading(true);
    setError(null);

    try {
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/conversations/${conversationId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('🗑️ Delete failed with status:', response.status, 'Error:', errorText);
        throw new Error(`Failed to delete conversation: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      setError(error.message || 'Failed to delete conversation');
      throw error; // Re-throw to let the component handle it
    } finally {
      setIsLoading(false);
    }
  };

  return { handleDeleteConversation, isLoading, error };
};

export default useDeleteConversation;



